import { computed, inject, Injectable } from '@angular/core';
import {
  ProjectJourneyEventKind,
  ReprocessRecognitionRequest,
  ReprocessRecognitionResult,
} from '@lite-workspace/dto-fotoclass-common';

import { ProjectJourneyStore } from '../+state/project-journey.store';
import {
  failReasonLabel,
  PROJECT_JOURNEY_EVENT_LABEL,
  PROJECT_JOURNEY_UNIT_ORDER,
  PROJECT_JOURNEY_UNIT_SERVICES,
  PROJECT_JOURNEY_UNIT_TITLE,
  ProjectJourneyUnitView,
} from '../entities/project-journey.types';

@Injectable({ providedIn: 'root' })
export class ProjectJourneyFacade {
  private readonly store = inject(ProjectJourneyStore);

  //#region Project journey
  projectId = this.store.projectId;
  loading = this.store.snapshotLoading;
  loaded = this.store.snapshotLoaded;
  error = this.store.snapshotError;
  connected = this.store.connected;
  feed = this.store.feed;

  unitViews = computed<ProjectJourneyUnitView[]>(() => {
    const units = this.store.units();
    return PROJECT_JOURNEY_UNIT_ORDER.map(unit => {
      const counters = units[unit];
      return {
        unit,
        title: PROJECT_JOURNEY_UNIT_TITLE[unit],
        services: PROJECT_JOURNEY_UNIT_SERVICES[unit],
        counters: Object.entries(counters.counts).map(([kind, value]) => ({
          kind: kind as ProjectJourneyEventKind,
          label: PROJECT_JOURNEY_EVENT_LABEL[kind as ProjectJourneyEventKind],
          value: value ?? 0,
        })),
        failed: counters.failed,
        failReasons: (counters.topFailReasons ?? []).map(entry => ({
          reason: entry.reason,
          label: failReasonLabel(entry.reason),
          count: entry.count,
        })),
      };
    });
  });
  //#endregion Project journey

  //#region Project journey Methods
  selectProject(projectId: string): Promise<void> {
    return this.store.selectProject(projectId);
  }

  reloadSnapshot(): Promise<void> {
    return this.store.reloadSnapshot();
  }

  clearProject(): void {
    this.store.clearProject();
  }

  /** dryRun-план для диалога «вот что сейчас произойдёт». */
  dryRunReprocess(): Promise<ReprocessRecognitionResult> {
    return this.store.reprocessRecognition({ dryRun: true });
  }

  reprocessRecognition(request: ReprocessRecognitionRequest): Promise<ReprocessRecognitionResult> {
    return this.store.reprocessRecognition(request);
  }
  //#endregion Project journey Methods
}
